module.exports = __webpack_public_path__ + "img/twitter.58880cb4.svg";